/** Required-date offset used for new quotes. Weekends are not working days. */
export function workingDateAfter(days = 0, from = new Date()) {
  const date = new Date(from);
  let remaining = Math.max(0, Math.trunc(Number(days) || 0));
  while (remaining > 0) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== 0 && date.getDay() !== 6) remaining -= 1;
  }
  const pad = (value) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
